import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ShoppingService} from '../../component/services/shopping.service';
import {FilterService} from '../../component/services/filter.service';

@Injectable()
export class SaveCardGuard  {

  constructor(
    private shoppingService: ShoppingService,
    private filterService: FilterService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.shoppingService.shoppingCard.length > 0 || this.shoppingService.order.shoppingBag.length > 0) {
      if (confirm('Als u de busconfiguratie wijzigt, dan zal de winkelwagen leeg worden gemaakt, weet u zeker dat u wilt doorgaan?')) {
        this.shoppingService.clear();
        this.shoppingService.clearOrder();
        return true;
      } else {
        return false;
      }
    } else {
      this.filterService.clearType();
      this.filterService.clearBrand();
      return true;
    }
  }
}
